<template>
  <page name='HomePage'>
    <div id="logo_block">
      <img id="logo" src="img/logo.png" alt="Classical Walk Of Fame Music Player">
    </div>
    <p class="choose">Now Playing on Device and in Washington Park</p>
    <x-now-playing
      @click="$root.goto('FountainPage')"
      overrideImage="img/fountain_icon.png"
      text="Fountain"
      :inductee="$root.nowPlaying('fountain')"
    ></x-now-playing>
    <x-now-playing
      @click="$root.goto('PlazaPage')"
      overrideImage="img/plaza_icon.png"
      text="Plaza"
      :inductee="$root.nowPlaying('plaza')"
    ></x-now-playing>
    <x-now-playing
      @click="$root.device.length > 0 && $root.goto('DevicePage')"
      overrideImage="img/device_icon.png"
      text="Device"
      :inductee="$root.nowPlaying('device')"
    ></x-now-playing>
    <x-footer slot="footer">
      <a class="button" @click="$root.goto('InducteePage')">
        <img src="img/addcircle_icon.png" class="button-icon">Explore and Listen</span>
      </a>
      <external-link class="openwebsite" href="http://classicalwalkoffame.org/">Visit Our Website</external-link>
    </x-footer>
  </page>
</template>

<script>
export default {
  components: {
    'page': require('./Page.vue'),
    'x-now-playing': require('./NowPlaying.vue'),
    'x-footer': require('./Footer.vue'),
  }
}
</script>

<style lang="less">
main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
#logo_block {
  width: 80%;
  margin-top:10px;
  margin-left: 10%;
  margin-right: 10%;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: auto;
  }
}
.choose {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  color: #90adc6;
  font-weight: 700;
  text-align: center;
  margin: 0px 0px;
  padding-bottom: 10px;
  font-size: 1.2em;
  border-bottom: 1px solid #afd2ef;
}
.button_centerer {
  width: 280px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  top: -15px;
  @media (max-height: 480px) {
    margin-top: -5px;
  }
}
.fp_button {
  text-align: left;
  display: block;
  padding: 15px 0px;
  padding-left: 100px;
  width: 100%;
  vertical-align: middle;
  margin: 15px auto;
  color: #fff !important;
  font-size: 2.5em;
  font-family: "Open Sans", arial, sans-serif;
  font-weight: 300 !important;
  text-decoration: none;
  cursor: pointer;
  // @media (min-height: 480px and max-height: 800px) {
  //   font-size: 1.7em !important;
  // }
  // @media (max-height: 480px) {
  //   font-size: 1.4em !important;
  //   width: 76% !important;
  //   margin: 8px 12% !important;
  //   padding-left: 85px !important;
  // }
}

#device_button {
  background: url(img/device_icon.png) no-repeat left center;
  background-size: contain;
}

#fountain_button {
  background: url(img/fountain_icon.png) no-repeat left center;
  background-size: contain;
}

#plaza_button {
  background: url(img/plaza_icon.png) no-repeat left center;
  background-size: contain;
}

.openwebsite {
  color: #9a4aaf;
  font-size: 19px;
  display: block;
  margin: 5px;
  padding: 5px;
}
x-now-playing {
  cursor: pointer;
  flex-shrink: 2;
}
</style>